<template>
  <div class="home">
    <header-main />

    <main class="home-main">
      <div class="grid-container">
        <h4 class="q">This tool will analyze your company’s current marketing strategy and provide personalized feedback, based on your responses, to aid in creating your marketing REMIX.</h4>

        <h5 class="q q-req">The assessment takes between 5-10 minutes and requires a current understanding of your company's marketing plan.</h5>

        <h3 class="q strong">Are you ready to get started?</h3>

        <router-link :to="{ name: 'questions', params: {from: 'home', q: 0} }" class="btn btn-outline-light btn-lg">Let's Go!</router-link>
      </div>
    </main>
  </div>
</template>

<script>
import Header from '@/views/HeaderMain';

export default {
  name: 'home',
  components: {
    'header-main': Header
  },
  // data() {
  //   return {
  //     id: this.$store.state.q
  //   }
  // }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars';
@import '../assets/scss/mixins';

.home {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

.home-main {
  width: 100%;
  text-align: center;
  padding-bottom: gu(4);

  @media only screen and (min-width: 40rem) {
    padding-bottom: gu(6);
  }
}

.grid-container {
  padding: 0 gu(2);
}

.q-req {
  font-size: rem-calc(22);
  max-width: 54%;
  margin-bottom: gu(2);
}

h3 {
  margin-bottom: gu(1.5);
}

</style>
